import React, { useEffect, useState } from 'react'

import { hexToRGB } from '../../../../util/transformColor'
import { IUserStatisticData } from '../../../types/types'
import { ChartData } from 'chart.js'
import BarChart from '@professocial/professocialChartComponents/ChartComponents/BarChart'

const PostingBarChart: React.FC<IUserStatisticData> = (props) => {
  const [chartData, setChartData] = useState<ChartData | undefined>(props.data)

  useEffect(() => {
    props.data && createChartData(props.data)
  }, [props.data])

  const createChartData = (statisticsObj: ChartData) => {
    if (statisticsObj.datasets && statisticsObj.datasets.length > 0) {
      setChartData({
        labels: statisticsObj.labels,
        datasets: statisticsObj.datasets.map((dataset, index: number) => {
          return ({
            label: dataset.label,
            fill: true,
            data: dataset.data,
            backgroundColor: hexToRGB(props.colors[index], 0.7),
            borderColor: props.colors[index + 1],
            lineTension: 0,
          })
        }),
      })
    }
  }

  return (
    <div style={{ position: 'relative', margin: 'auto', height: '400px', width: '95%' }}>
      <BarChart
        type='bar'
        data={chartData as ChartData<'bar'>}
        height={100}
        options={{
          responsive: true,
          maintainAspectRatio: false
        }}
      />
    </div>
  )
}
export default PostingBarChart
